module.exports = __webpack_public_path__ + "static/media/Shaman_Restoration.32d53889.png";